import { createAsyncThunk } from "@reduxjs/toolkit"

import { API } from "redux/api"

export const fetchPurchasedProducts = createAsyncThunk(
  "purchased-products/fetch",
  async () => {
    const response = await API.get("/purchased_products")
    return response.data.purchased_products
  },
)
